export const FETCH_TASKS_MANAGER_FILTERS_INIT = 'FETCH_TASKS_MANAGER_FILTERS_INIT';
export const FETCH_TASKS_MANAGER_FILTERS_SUCCESS = 'FETCH_TASKS_MANAGER_FILTERS_SUCCESS';
export const FETCH_TASKS_MANAGER_FILTERS_FAILURE = 'FETCH_TASKS_MANAGER_FILTERS_FAILURE';
export const SET_FILTER_TASKS_MANAGER = 'SET_FILTER_TASKS_MANAGER';



// WEBPACK FOOTER //
// ./source/client/actions/tasks_manager/types.js